import { VStack } from '@genial/components';
import { ResponsesFundItemResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { FlatList } from 'native-base';
import React, { useState } from 'react';

import { dataContent } from '../../../../../../constants';
import { validateAndFormatValue } from '../../../../Table/constants';
import { messageError } from '../../constants';
import { ItemSeparatorComponent } from '../MovementationDetails';
import { TableHead } from '../TableHead';

import { MovementItemDesktop } from './desktop';
import { MovementItemHeader } from './header';
import { MovementItemMobile } from './mobile';
import { MovementItemTablet } from './tablet';

interface MovementItemProps {
  item: ResponsesFundItemResponse;
}

export interface MovementItemResponsiveProps {
  movementDate: string;
  quotationDate: string;
  historic: string;
  quotaValue: string;
  quotaQuantity: string | number;
  grossValue: string;
  irValue: string;
  iofValue: string;
  penaltyValue: string;
  netValue: string;
}

export const MovementItem: React.FC<MovementItemProps> = ({ item }) => {
  const FundMovementItemResponsive = useBreakpointValue({
    base: (params: MovementItemResponsiveProps) => <MovementItemMobile {...params} />,
    sm: (params: MovementItemResponsiveProps) => <MovementItemTablet {...params} />,
    lg: (params: MovementItemResponsiveProps) => <MovementItemDesktop {...params} />,
  });
  const itemSeparator = useBreakpointValue({ base: ItemSeparatorComponent, sm: null });

  const headParams = dataContent.fundMovementStatements;

  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const [isOpened, setIsOpened] = useState(false);
  const handleChangeIsOpened = () => setIsOpened((state) => !state);

  return (
    <VStack>
      <MovementItemHeader
        fundName={item.fundName || messageError}
        fundCnpj={item.fundCnpj || messageError}
        handleChangeIsOpened={handleChangeIsOpened}
        isOpened={isOpened}
      />
      {isOpened && (
        <VStack>
          {isDesktop && <TableHead {...headParams} />}
          <FlatList
            data={item.fundMovements}
            ItemSeparatorComponent={itemSeparator}
            showsVerticalScrollIndicator={false}
            keyExtractor={(key, index) => `${key.movementDate}-${index}`}
            renderItem={({ item: fundMovement }) => {
              const fundMovementParams = {
                movementDate: validateAndFormatValue(fundMovement?.movementDate as Date, 'date'),
                quotationDate: validateAndFormatValue(fundMovement?.quotationDate as Date, 'date'),
                historic: fundMovement?.historic || messageError,
                quotaValue: validateAndFormatValue(fundMovement?.quotaValue as number, 'money'),
                quotaQuantity: fundMovement?.quotaQuantity || messageError,
                grossValue: validateAndFormatValue(fundMovement?.grossValue as number, 'money'),
                irValue: validateAndFormatValue(fundMovement?.irValue as number, 'money'),
                iofValue: validateAndFormatValue(fundMovement?.iofValue as number, 'money'),
                penaltyValue: validateAndFormatValue(fundMovement?.penaltyValue as number, 'money'),
                netValue: validateAndFormatValue(fundMovement?.netValue as number, 'money'),
              };

              return <FundMovementItemResponsive {...fundMovementParams} />;
            }}
          />
        </VStack>
      )}
    </VStack>
  );
};
